var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useEffect, useState } from 'react';
import { GoogleMap, Marker, Polyline, useJsApiLoader } from '@react-google-maps/api';
import { Grid, Typography, CircularProgress, Box } from '@mui/material';
import { registerPlugin } from "@capacitor/core";
var BackgroundGeolocation = registerPlugin("BackgroundGeolocation");
import { chunk } from 'lodash';
import { calculateTotalDistance, fetchDirections, getCordinatesFromDirectionResponse } from './mapViewUtils';
import { Config } from '../../../api/config';
import { MuiStack } from '../../atoms/stackComponent';
import { EndPointMarkerIcon, StartPointMarkerIcon } from '../../../assets/images';
import { systemColor } from '../../../theme/systemColor';
import { detectPlatform } from '../../../builderPackage/common/commonFunctions';
var MapView = function (_ref) {
    var currentPosition = _ref.currentPosition, roadTestStatus = _ref.roadTestStatus, setDistance = _ref.setDistance, endTestHandler = _ref.endTestHandler, existingCoords = _ref.existingCoords;
    var _a = useJsApiLoader({
        id: 'google-map-script-191',
        googleMapsApiKey: Config.GoogelMapAPIKey
    }), isLoaded = _a.isLoaded, loadError = _a.loadError;
    var mapContainerStyle = {
        width: '100%',
        height: '400px'
    };
    var _b = useState([]), coordinates = _b[0], setCoordinates = _b[1];
    var _c = useState(existingCoords ? existingCoords : []), refinedCords = _c[0], setRefinedCords = _c[1];
    var _d = useState(false), isLoading = _d[0], setIsLoading = _d[1];
    var platform = detectPlatform();
    var interval;
    useEffect(function () {
        if (roadTestStatus == 'started') {
            startTest();
        }
        else if (roadTestStatus === 'ended') {
            endTest();
        }
        if (existingCoords && existingCoords.length > 0) {
            setRefinedCords(existingCoords);
        }
    }, [roadTestStatus, existingCoords]);
    var id = null;
    var watchPositionNative = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, BackgroundGeolocation.addWatcher({
                        // On Android, the plugin shows a notification which allows it to
                        // continue receiving location updates in the background. If this option
                        // is undefined, the notification is not delivered and hence background
                        // location updates are not guaranteed.
                        backgroundMessage: "",
                        // The title for the notification. Defaults to "Using your location".
                        backgroundTitle: "",
                        // Whether permissions should be requested from the user automatically,
                        // if they are not already granted. Defaults to "true".
                        requestPermissions: true,
                        // If "true", stale locations may be delivered while the device
                        // obtains a GPS fix. You are responsible for checking the "time"
                        // property. If "false", locations are guaranteed to be up to date.
                        // Defaults to "false".
                        stale: false,
                        // The minimum number of metres between subsequent locations. Defaults
                        // to 0.
                        distanceFilter: 0
                    }, function callback(location, error) {
                        if (error && error.cause) {
                            alert("Mapview error :" + error.cause);
                        }
                        if (location) {
                            var latitude = location.latitude, longitude = location.longitude;
                            var newLocation_1 = {
                                lat: latitude,
                                lng: longitude
                            };
                            setCoordinates(function (prevCoords) { return __spreadArray(__spreadArray([], prevCoords, true), [newLocation_1], false); });
                        }
                    })];
                case 1:
                    id = _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var watchPositionWeb = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            navigator.geolocation.watchPosition(function (position) {
                if (position) {
                    var _a = position.coords, latitude = _a.latitude, longitude = _a.longitude;
                    var newLocation_2 = {
                        lat: latitude,
                        lng: longitude
                    };
                    setCoordinates(function (prevCoords) { return __spreadArray(__spreadArray([], prevCoords, true), [newLocation_2], false); });
                }
            }, function (error) {
                console.log(error.message);
            }, {
                enableHighAccuracy: true,
                maximumAge: 0,
                timeout: 2000
            });
            return [2 /*return*/];
        });
    }); };
    var startTest = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            setIsLoading(true);
            if (platform === 'android' || platform === 'ios') {
                watchPositionNative();
            }
            else {
                watchPositionWeb();
            }
            return [2 /*return*/];
        });
    }); };
    var endTest = function () { return __awaiter(void 0, void 0, void 0, function () {
        var promArray, pathChunks, _i, pathChunks_1, pathChunkItem, start, end;
        return __generator(this, function (_a) {
            console.log("_______");
            promArray = [];
            pathChunks = chunk(coordinates, 25);
            console.log("___HERE", pathChunks);
            for (_i = 0, pathChunks_1 = pathChunks; _i < pathChunks_1.length; _i++) {
                pathChunkItem = pathChunks_1[_i];
                start = pathChunkItem[0];
                end = pathChunkItem[pathChunkItem.length - 1];
                pathChunkItem.shift();
                pathChunkItem.pop();
                promArray.push(fetchDirections(start, end, pathChunkItem));
            }
            Promise.all(promArray).then(function (res) {
                var refinedCoords = [];
                for (var _i = 0, _a = res.flat(); _i < _a.length; _i++) {
                    var element = _a[_i];
                    if (element) {
                        refinedCoords = __spreadArray(__spreadArray([], refinedCoords, true), getCordinatesFromDirectionResponse(element), true);
                    }
                }
                setRefinedCords(refinedCoords);
                setCoordinates([]);
                setDistance(calculateTotalDistance(coordinates));
                endTestHandler(String(calculateTotalDistance(coordinates).toFixed(2)), refinedCoords);
            }).catch(function () {
                alert("Error while fetching direction.");
            }).finally(function () {
                setIsLoading(false);
            });
            return [2 /*return*/];
        });
    }); };
    function convertSecondsToFormattedTime(seconds) {
        // Calculate minutes and remaining seconds
        var minutes = Math.floor(seconds / 60);
        var remainingSeconds = seconds % 60;
        var formattedTime = "".concat(seconds, " Sec");
        if (minutes === 0) {
            formattedTime = "".concat(remainingSeconds, " Sec");
        }
        else {
            formattedTime = "".concat(minutes, " Min ").concat(remainingSeconds, " Sec");
        }
        return formattedTime;
    }
    if (loadError) {
        console.error('Error loading Google Maps API', loadError);
        return /*#__PURE__*/ React.createElement("div", null, "Error loading map");
    }
    var CircularProgressWithText = function () {
        return /*#__PURE__*/ React.createElement(Box, {
            position: "relative",
            display: "inline-flex"
        }, /*#__PURE__*/ React.createElement(CircularProgress, {
            size: 30,
            sx: {
                color: systemColor.primary
            }
        }), /*#__PURE__*/ React.createElement(Box, {
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            position: "absolute",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
        }, /*#__PURE__*/ React.createElement(Typography, {
            variant: "caption"
        }, "1")));
    };
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        padding: 1,
        justifyContent: 'center'
    }, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        lg: 12,
        md: 12
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        direction: "column"
    }, isLoaded && currentPosition && !isLoading && /*#__PURE__*/ React.createElement(GoogleMap, {
        mapContainerStyle: mapContainerStyle,
        center: currentPosition,
        zoom: 13,
        options: {
            zoomControl: true,
            streetViewControl: false,
            mapTypeControl: false,
            fullscreenControl: true,
            keyboardShortcuts: false
        }
    }, refinedCords.length >= 2 && /*#__PURE__*/ React.createElement(Marker, {
        icon: {
            url: StartPointMarkerIcon,
            scaledSize: new window.google.maps.Size(90, 42)
        },
        position: refinedCords[0] // first element of refined coords.
    }), refinedCords.length >= 2 && /*#__PURE__*/ React.createElement(Marker, {
        icon: {
            url: EndPointMarkerIcon,
            scaledSize: new window.google.maps.Size(90, 42)
        },
        position: refinedCords[refinedCords.length - 1]
    }) // last element of refined coords.
    , refinedCords.length > 1 && /*#__PURE__*/ React.createElement(Polyline, {
        path: refinedCords,
        options: {
            strokeColor: "#FF0000",
            // Red polyline
            strokeOpacity: 1.0,
            strokeWeight: 2
        }
    })), isLoading && /*#__PURE__*/ React.createElement(MuiStack, {
        justifyContent: 'center',
        alignItems: 'center',
        spacing: 1
    }, /*#__PURE__*/ React.createElement(CircularProgress, {
        size: 30,
        sx: {
            color: systemColor.primary
        }
    })), platform === "web" && isLoading && /*#__PURE__*/ React.createElement(Typography, {
        variant: "subtitle1",
        color: 'red'
    }, "Please do not turn off this window.")))));
};
export default MapView;
